module.exports = __webpack_public_path__ + "img/ic_paypal@2x.8a2b1072.png";